import check from '../images/check-white-thin.svg';
import { VersionStep } from '../types';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

type StepVersionProps = {
    theme: string;
    step: VersionStep;
    result: boolean;
    verified: boolean;
    lessonValidation: boolean[];
};

function StepVersion({ theme, step, result, verified, lessonValidation }: StepVersionProps) {
    const { t } = useTranslation();
    const [stepSucceeded, setStepSucceeded] = useState(false);
    const [showAnimation, setShowAnimation] = useState(false);

    useEffect(() => {
        setStepSucceeded(result);
        if (!result && verified && !lessonValidation[step.id]) {
            setShowAnimation(true);
            const timer = setTimeout(() => {
                setShowAnimation(false);
            }, 700);
            return () => clearTimeout(timer);
        }
    }, [result, step, verified, lessonValidation]);

    return (
        <div className="flex  flex-row items-center justify-between px-4 py-4">
            <p
                className={`text-[15px] text-start pr-20 font-semibold duration-200
       
    ${
        verified
            ? result
                ? 'duration-700 text-text-dark'
                : `text-red-400 ${showAnimation ? 'animate-nope' : ''}`
            : 'duration-700 text-text-dark'
    }`}
            >
                {t(step.name)}
            </p>
            {stepSucceeded ? (
                <div
                    className={`flex justify-center items-center flex-shrink-0 w-6 h-6 rounded-full bg-ar-${theme} shadow-${theme}`}
                >
                    <img className="h-[9px]" src={check} alt="Check" />
                </div>
            ) : (
                <div className="w-6 h-6 shrink-0 rounded-full bg-gray-100/50 border border-gray-200/70"></div>
            )}
        </div>
    );
}

export default StepVersion;
